export default "__VITE_ASSET__5cab4fad__"